const ranking = [
  {
    rank: 1,
    title: '知名导演被曝潜规则多名新人，行业内幕大揭秘',
    tag: '独家爆料',
    hot: '356.7万',
    trend: 'up',
  },
  {
    rank: 2,
    title: '头部网红直播带货翻车，产品质量遭集体投诉',
    tag: '直播翻车',
    hot: '203.1万',
    trend: 'up',
  },
  {
    rank: 3,
    title: '热门综艺录制现场嘉宾翻脸，节目组紧急协调',
    tag: '综艺内幕',
    hot: '178.2万',
    trend: 'up',
  },
  {
    rank: 4,
    title: '顶流男星恋情曝光，深夜密会照片引全网热议',
    tag: '恋情曝光',
    hot: '145.8万',
    trend: 'down',
  },
  {
    rank: 5,
    title: '娱乐圈塌房年度盘点，2024年人设崩塌全记录',
    tag: '年度盘点',
    hot: '128.6万',
    trend: 'up',
  },
  {
    rank: 6,
    title: '国际品牌代言人突然更换，原团队拒绝回应',
    tag: '代言风波',
    hot: '112.4万',
    trend: 'new',
  },
];

const rankColors: Record<number, string> = {
  1: 'bg-primary-500',
  2: 'bg-primary-400',
  3: 'bg-accent-500',
};

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-8 md:mb-10">
          <div className="w-1 h-6 md:h-7 rounded-full bg-primary-500"></div>
          <h2 className="text-xl md:text-2xl font-heading text-foreground-950">爆料热度榜</h2>
        </div>

        <div className="bg-background-100 rounded-2xl border border-background-200/70 overflow-hidden">
          {ranking.map((item) => (
            <div
              key={item.rank}
              className="flex items-center gap-4 px-5 md:px-6 py-4 border-b border-background-200/70 last:border-b-0 hover:bg-background-50 transition-colors cursor-pointer group"
            >
              <div className={`flex-shrink-0 w-8 h-8 rounded-lg flex items-center justify-center text-white text-sm font-bold ${
                rankColors[item.rank] || 'bg-secondary-400'
              }`}>
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm md:text-base font-medium text-foreground-800 leading-snug line-clamp-1 group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
                <div className="flex items-center gap-2 mt-1">
                  <span className="text-xs px-1.5 py-0.5 rounded bg-accent-100 text-accent-700 font-medium whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="flex-shrink-0 flex items-center gap-2 text-sm font-semibold text-foreground-800">
                <i className={`${
                  item.trend === 'up' ? 'ri-arrow-up-line text-primary-500' :
                  item.trend === 'down' ? 'ri-arrow-down-line text-secondary-400' :
                  'ri-sparkling-line text-accent-500'
                }`}></i>
                <span>{item.hot}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}